import { render, staticRenderFns } from "./VesselMonitoringPage.vue?vue&type=template&id=3333a534&scoped=true"
import script from "./VesselMonitoringPage.vue?vue&type=script&lang=js"
export * from "./VesselMonitoringPage.vue?vue&type=script&lang=js"
import style0 from "./VesselMonitoringPage.vue?vue&type=style&index=0&id=3333a534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3333a534",
  null
  
)

export default component.exports